var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.1 1.294a.75.75 0 0 1 1.06 0l3.335 3.333a.75.75 0 0 1-1.06 1.06L9.38 3.635v10.618a.75.75 0 0 1-1.5 0V3.634L5.828 5.688a.75.75 0 0 1-1.06-1.06z"
  })));
};
export default Svg16;